import React from 'react'
import cx from 'classnames'

import s from './List.scss'


type ListProps = {
  size?: 'sm' | 'md' | 'lg'
}

const List: React.FunctionComponent<ListProps> = ({ children, size }) => (
  <div>
    {
      React.Children.map(children, (child, index) => {
        const key       = React.isValidElement(child) ? child.key || index : index
        const className = cx(s.item, s[`size-${size}`])

        return (
          <div key={key} className={className}>
            {child}
          </div>
        )
      })
    }
  </div>
)


export default List
